export default {"src":"/_next/static/media/not-helpful.6412df0e.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};